<template>
  <div class="chat-widget">
    <!-- Telegram 悬浮客服按钮 -->
    <div style="" class="telegram-fab" @click="openTelegram" title="Telegram 客服">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
      </svg>
    </div>

    
	

    <!-- 聊天窗口 -->
    <transition name="chat-slide">
      <div class="chat-panel" v-if="isOpen">
        <!-- 头部 -->
        <div class="chat-header">
          <div class="chat-header-info">
            <div class="agent-avatar">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
              </svg>
            </div>
            <div>
              <div class="agent-name">VTO-TOP 客服</div>
              <div class="agent-status" :class="connectionStatus">
                {{ statusText }}
              </div>
            </div>
          </div>
          <div class="chat-header-actions">
            <button class="btn-minimize" @click="isOpen = false" title="最小化">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </button>
            <button class="btn-close" @click="closeChat" title="关闭">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- 消息区域 -->
        <div class="chat-messages" ref="chatMessages">
          <div class="message system" v-if="messages.length === 0 && !historyLoaded">
            <div class="msg-bubble system-bubble">
              正在加载消息...
            </div>
          </div>
          <div class="message system" v-if="messages.length === 0 && historyLoaded">
            <div class="msg-bubble system-bubble">
              您好！欢迎使用 VTO-TOP 客服系统。请问有什么可以帮您？
            </div>
          </div>
          <div
            class="message"
            :class="msg.type"
            v-for="(msg, idx) in messages"
            :key="idx"
          >
            <div class="msg-time" v-if="msg.time">{{ msg.time }}</div>
            <div class="msg-bubble" :class="msg.type + '-bubble' + (msg.msgType === 'image' ? ' msg-image-bubble' : '')">
              <img v-if="msg.msgType === 'image'" :src="msg.text" class="msg-image" @load="scrollToBottom" />
              <span v-else>{{ msg.text }}</span>
            </div>
            <button
              v-if="isLoggedIn && msg.msgId && msg.type === 'agent'"
              class="btn-recall"
              @click="recallMessage(msg.msgId)"
              title="撤回"
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- 输入区域 -->
        <div class="chat-input-area">
          <div class="input-toolbar">
            <button class="toolbar-btn" @click="triggerImageUpload" title="发送图片">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <path d="M21 15l-5-5L5 21"/>
              </svg>
            </button>
            <input type="file" ref="fileInput" accept="image/*" style="display:none" @change="handleImageSelect" />
          </div>
          <div class="input-row">
            <textarea
              class="chat-input"
              v-model="inputText"
              :placeholder="isConnected ? '输入消息...' : '连接中...'"
              @keydown.enter.exact="sendMessage"
              rows="2"
              :disabled="!isConnected || !sessionId"
            ></textarea>
            <button
              class="btn-send"
              @click="sendMessage"
              :disabled="!inputText.trim() || !isConnected || !sessionId"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import request from '../utils/request'
import { recallChatMessage, markChatRead } from '../api/index'

export default {
  name: 'ChatWidget',
  props: {
    // 渠道码，默认 'platform'（平台客服），会员可传入自己的渠道码
    channelCode: {
      type: String,
      default: 'platform'
    }
  },
  data() {
    return {
      isOpen: false,
      ws: null,
      isConnected: false,
      isAuthed: false,
      inputText: '',
	  visitorIp: '',
      messages: [],
      unreadCount: 0,
      reconnectTimer: null,
      heartbeatTimer: null,
      sessionId: null,
      historyLoaded: false,
      historyLoadedOnce: false,
      adminOnline: false,
      wsUrl: process.env.VUE_APP_WS_URL || 'wss://linux.aieaa.com/wss'
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.token
    },
    connectionStatus() {
      return this.adminOnline ? 'online' : 'offline'
    },
    statusText() {
      return this.adminOnline ? '在线' : '离线'
    }
  },
  watch: {
    isLoggedIn(newVal) {
      // 登录后更新访客名字为邮箱
      if (newVal && this.isConnected && this.sessionId) {
        const email = this.$store.state.user?.email || this.$store.state.user?.username || ''
        if (email) {
          this.wsSend({ type: 'update_name', name: email })
        }
      }
    }
  },
  mounted() {
    // 访客聊天全页面不启动 ChatWidget（同时检查路由和实际 URL）
    const routePath = this.$route.path || ''
    const urlPath = window.location.pathname || ''
    if (routePath.startsWith('/chat/c/') || urlPath.startsWith('/chat/c/')) {
      console.log('[ChatWidget] 访客聊天页面，跳过初始化')
      return
    }
    this.connectWebSocket()
    // 监听路由变化，如果切换到访客聊天页面则断开连接
    this.$watch(
      () => this.$route.path,
      (newPath) => {
        if (newPath && newPath.startsWith('/chat/c/')) {
          console.log('[ChatWidget] 路由切换到访客聊天页面，断开连接')
          this.closeWebSocket()
          this.clearHeartbeat()
        } else if (!this.ws) {
          // 路由切换回非访客页面，重新连接
          this.connectWebSocket()
        }
      }
    )
  },
  beforeDestroy() {
    this.closeWebSocket()
    this.clearHeartbeat()
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }
  },
  methods: {
	  async fetchVisitorIp() {
	    try {
	      const request = (await import('../utils/request')).default
	      const res = await request({ url: '/visitor/ip', method: 'get' })
	      if (res.code === 200 && res.data && res.data.ip) {
	        this.visitorIp = res.data.ip
	      }
	    } catch (e) {
	      console.warn('[ChatWidget] 获取 IP 失败:', e)
	    }
	  },
    toggleChat() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.unreadCount = 0
        // 打开面板时加载历史消息
        if (!this.historyLoadedOnce && this.sessionId) {
          this.loadHistory()
        }
        // 打开聊天窗口时标记已读
        if (this.sessionId) {
          this.sendMarkRead()
        }
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
    },
    closeChat() {
      this.isOpen = false
    },
    connectWebSocket() {
      this.fetchVisitorIp().then(() => {
        if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
          return
        }
    
        try {
          this.ws = new WebSocket(this.wsUrl)
    
          this.ws.onopen = () => {
            console.log('[ChatWS] 连接成功')
            this.isConnected = true
            const visitorId = localStorage.getItem('visitor_id') || ('v_' + Math.random().toString(36).substr(2, 8) + Math.random().toString(36).substr(2, 8))
            localStorage.setItem('visitor_id', visitorId)
            this.wsSend({ type: 'join', channel: this.channelCode, visitor_id: visitorId, ip: this.visitorIp })
            if (this.isLoggedIn) {
              const email = this.$store.state.user?.email || this.$store.state.user?.username || ''
              if (email) {
                this.wsSend({ type: 'update_name', name: email })
              }
            }
            this.startHeartbeat()
          }
    
          this.ws.onmessage = (event) => {
            try {
              const data = JSON.parse(event.data)
              this.handleMessage(data)
            } catch (e) {
              console.warn('[ChatWS] 消息解析失败:', e)
            }
          }
    
          this.ws.onclose = () => {
            this.isConnected = false
            this.scheduleReconnect()
          }
    
          this.ws.onerror = (e) => {
            console.error('[ChatWS] 连接错误:', e)
          }
        } catch (e) {
          console.error('[ChatWS] 创建连接失败:', e)
        }
      })
    },
    handleMessage(data) {
      switch (data.type) {
        case 'welcome':
          break
        case 'auth_ok':
          // ChatWidget 不再使用认证流程，忽略
          break
        case 'auth_fail':
          // ChatWidget 不再使用认证流程，忽略
          break
        case 'joined':
          console.log('[ChatWS] 已加入渠道, session_id:', data.session_id)
          this.sessionId = data.session_id
          this.historyLoaded = false
          this.historyLoadedOnce = false
          if (this.isOpen) {
            this.loadHistory()
          }
          break
        case 'chat':
          this.handleChatMessage(data)
          break
        case 'system':
          this.addMessage({
            type: 'system',
            text: data.content || data.msg || '',
            time: this.formatTime()
          })
          break
        case 'pong':
          break
        case 'recall':
          // 无痕撤回：从消息列表中移除
          this.messages = this.messages.filter(m => m.msgId !== data.msg_id)
          break
        case 'messages_read':
          break
        case 'admin_online':
          this.adminOnline = true
          break
        case 'admin_offline':
          this.adminOnline = false
          break
        case 'error':
          console.error('[ChatWS] 服务器错误:', data.msg)
          break
        default:
          break
      }

      this.$nextTick(() => this.scrollToBottom())
    },
    handleChatMessage(data) {
      const userId = this.$store.state.user?.id
      const isSelf = data.from_type === 'visitor' && userId && data.from_id === userId
      const msgData = {
        type: isSelf ? 'user' : 'agent',
        text: data.content,
        msgType: data.msg_type || 'text',
        msgId: data.msg_id,
        time: data.create_time ? this.formatTime(new Date(data.create_time * 1000)) : this.formatTime()
      }

      // 去重：检查是否已存在相同 msg_id 的消息
      if (data.msg_id) {
        const existingIdx = this.messages.findIndex(m => m.msgId === data.msg_id)
        if (existingIdx >= 0) return // 已存在，跳过

        // 检查是否是本地刚发送的消息（无 msgId，内容相同）→ 更新 msgId 而非重复添加
        const lastMsg = this.messages[this.messages.length - 1]
        if (lastMsg && !lastMsg.msgId && lastMsg.text === data.content && lastMsg.type === msgData.type) {
          this.$set(this.messages, this.messages.length - 1, msgData)
          return
        }
      }

      this.addMessage(msgData)

      if (!this.isOpen) {
        this.unreadCount++
      }
    },
    async loadHistory() {
      if (!this.sessionId || this.historyLoadedOnce) return
      this.historyLoadedOnce = true

      try {
        const role = this.isLoggedIn ? 'agent' : 'visitor'
        const res = await request({
          url: '/chat/history',
          method: 'get',
          params: { session_id: this.sessionId, page: 1, limit: 50, role }
        })
        if (res.code === 200 && res.data && res.data.list) {
          this.messages = []
          res.data.list.forEach(msg => {
            // 非管理员看不到已撤回的消息
            if (msg.is_deleted) return
            this.messages.push({
              type: msg.from_type === 'visitor' ? 'user' : 'agent',
              text: msg.content,
              msgType: msg.msg_type || 'text',
              msgId: msg.id,
              time: msg.create_time ? this.formatTime(new Date(msg.create_time * 1000)) : ''
            })
          })
          this.historyLoaded = true
          this.$nextTick(() => this.scrollToBottom())
        }
      } catch (e) {
        console.error('[ChatWS] 加载历史消息失败:', e)
        this.historyLoaded = true
      }
    },
    sendMessage() {
      const text = this.inputText.trim()
      if (!text || !this.isConnected || !this.sessionId) return

      this.addMessage({
        type: 'user',
        text,
        msgType: 'text',
        time: this.formatTime()
      })

      this.wsSend({
        type: 'chat',
        content: text,
        msg_type: 'text'
      })

      this.inputText = ''
      this.$nextTick(() => this.scrollToBottom())
    },
    triggerImageUpload() {
      this.$refs.fileInput.click()
    },
    handleImageSelect(e) {
      const file = e.target.files[0]
      if (!file) return

      if (file.size > 2 * 1024 * 1024) {
        alert('图片大小不能超过 2MB')
        return
      }

      const reader = new FileReader()
      reader.onload = (ev) => {
        const base64 = ev.target.result

        this.addMessage({
          type: 'user',
          text: base64,
          msgType: 'image',
          time: this.formatTime()
        })

        this.wsSend({
          type: 'chat',
          content: base64,
          msg_type: 'image'
        })

        this.$nextTick(() => this.scrollToBottom())
      }
      reader.readAsDataURL(file)
      e.target.value = ''
    },
    wsSend(data) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(data))
      }
    },
    addMessage(msg) {
      this.messages.push(msg)
    },
    closeWebSocket() {
      if (this.ws) {
        this.ws.close()
        this.ws = null
      }
      this.isConnected = false
      this.isAuthed = false
    },
    startHeartbeat() {
      this.clearHeartbeat()
      this.heartbeatTimer = setInterval(() => {
        this.wsSend({ type: 'ping' })
      }, 30000)
    },
    clearHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer)
        this.heartbeatTimer = null
      }
    },
    scheduleReconnect() {
      if (this.reconnectTimer) return
      this.reconnectTimer = setTimeout(() => {
        this.reconnectTimer = null
        this.connectWebSocket()
      }, 5000)
    },
    scrollToBottom() {
      const el = this.$refs.chatMessages
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    },
    sendMarkRead() {
      if (this.sessionId) {
        // 通过 WSS 发送 mark_read
        this.wsSend({ type: 'mark_read', session_id: this.sessionId })
        // 同时通过 REST API 标记
        markChatRead({ session_id: this.sessionId }).catch(() => {})
      }
    },
    async recallMessage(msgId) {
      if (!msgId || !this.sessionId) return
      try {
        const res = await recallChatMessage({ msg_id: msgId, session_id: this.sessionId })
        if (res.code === 200) {
          // 无痕撤回：直接从本地移除
          this.messages = this.messages.filter(m => m.msgId !== msgId)
        }
      } catch (e) {
        console.error('[ChatWS] 撤回失败:', e)
      }
    },
    formatTime(date) {
      const d = date || new Date()
      const h = String(d.getHours()).padStart(2, '0')
      const m = String(d.getMinutes()).padStart(2, '0')
      return h + ':' + m
    },
    openTelegram() {
      window.open('https://t.me/vtotopcome', '_blank')
    }
  }
}
</script>

<style scoped>
.chat-widget {
  position: fixed;
  bottom: 80px;
  right: 24px;
  z-index: 9999;
}

/* Telegram 悬浮按钮 */
.telegram-fab {
  width: 56px;
  height: 56px;
  background: #2AABEE;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(42, 171, 238, 0.4);
  transition: all 0.3s;
  position: relative;
  margin-bottom: 16px;
}

.telegram-fab:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(42, 171, 238, 0.5);
}

/* 悬浮按钮 */
.chat-fab {
  width: 56px;
  height: 56px;
  background: #2563eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.4);
  transition: all 0.3s;
  position: relative;
}

.chat-fab:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.5);
}

.unread-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

/* 聊天面板 */
.chat-panel {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 380px;
  height: 520px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 10000;
}

/* 头部 */
.chat-header {
  background: linear-gradient(135deg, #1a3a8f 0%, #2563eb 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.chat-header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.agent-avatar {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agent-name {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}

.agent-status {
  font-size: 12px;
  margin-top: 2px;
}

.agent-status.online {
  color: #86efac;
}

.agent-status.offline {
  color: #f87171;
}

.agent-status.connected {
  color: #86efac;
}

.agent-status.connecting,
.agent-status.authenticating {
  color: #fde68a;
}

.chat-header-actions {
  display: flex;
  gap: 4px;
}

.btn-minimize,
.btn-close {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.btn-minimize:hover,
.btn-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* 消息区域 */
.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f8f9ff;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.chat-messages::-webkit-scrollbar {
  width: 4px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 2px;
}

.message {
  display: flex;
  flex-direction: column;
  max-width: 85%;
}

.message.user {
  align-self: flex-end;
  align-items: flex-end;
}

.message.agent,
.message.system {
  align-self: flex-start;
  align-items: flex-start;
}

.msg-time {
  font-size: 11px;
  color: #9ca3af;
  margin-bottom: 4px;
}

.msg-bubble {
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
}

.user-bubble {
  background: #2563eb;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.agent-bubble {
  background: #fff;
  color: #1a1a2e;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.system-bubble {
  background: #e5e7eb;
  color: #6b7280;
  font-size: 13px;
  text-align: center;
  align-self: center;
  max-width: 90%;
}

.msg-image-bubble {
  padding: 4px !important;
}

.msg-image {
  max-width: 240px;
  max-height: 200px;
  border-radius: 8px;
  display: block;
}

/* 输入区域 */
.chat-input-area {
  background: #fff;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.input-toolbar {
  display: flex;
  gap: 4px;
  padding: 8px 12px 0;
}

.toolbar-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #f0f4ff;
  border-radius: 8px;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.toolbar-btn:hover {
  background: #e8edfb;
  color: #2563eb;
}

.input-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 8px 12px 12px;
}

.chat-input {
  flex: 1;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  resize: none;
  outline: none;
  font-family: inherit;
  line-height: 1.4;
  max-height: 80px;
  transition: border-color 0.3s;
}

.chat-input:focus {
  border-color: #2563eb;
}

.chat-input:disabled {
  background: #f9fafb;
  cursor: not-allowed;
}

.btn-send {
  width: 40px;
  height: 40px;
  background: #2563eb;
  border: none;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.btn-send:hover:not(:disabled) {
  background: #1d4ed8;
}

.btn-send:disabled {
  background: #d1d5db;
  cursor: not-allowed;
}

/* 撤回按钮 */
.btn-recall {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 2px 4px;
  margin-top: 2px;
  border-radius: 4px;
  opacity: 0;
  transition: all 0.2s;
}

.message:hover .btn-recall {
  opacity: 1;
}

.btn-recall:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

/* 滑入动画 */
.chat-slide-enter-active,
.chat-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-slide-enter {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}

.chat-slide-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}
</style>
